export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id=" arrow_style04/down">
<path id="Vector" d="M15.0949 18.8834C15.5723 19.4388 16.4275 19.4388 16.905 18.8834L20.5054 14.6955C21.1769 13.9144 20.6261 12.7 19.6004 12.7H12.3995C11.3738 12.7 10.823 13.9144 11.4944 14.6955L15.0949 18.8834Z"/>
</g>
</svg>
